const bahia = [
  //Bahia
  {
    id: 54,
    pais: "brasil",
    liga: "serie-a",
    time: "bahia",
    nome: "Bahia 25/26 Uniforme 1 ",
    aliases: [
      "bahia",
      "esporte clube bahia",
      "ec bahia",
      "tricolor de aço",
      "tricolor",
      "bahia ba",
      "esquadrão",
      "esquadrão de aço",
      "bahia 2025",
      "2025",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/bahia/25-26-01/bahia0.jpg",
      "/images/brasil/serie-a/bahia/25-26-01/bahia1.jpg",
      "/images/brasil/serie-a/bahia/25-26-01/bahia2.jpg",
      "/images/brasil/serie-a/bahia/25-26-01/bahia3.jpg",
      "/images/brasil/serie-a/bahia/25-26-01/bahia4.jpg",
    ],
  },
  {
    id: 55,
    pais: "brasil",
    liga: "serie-a",
    time: "bahia",
    nome: "Bahia 25/26 Uniforme 1 (Feminino) ",
    aliases: [
      "bahia",
      "esporte clube bahia",
      "ec bahia",
      "tricolor de aço",
      "tricolor",
      "bahia ba",
      "esquadrão",
      "esquadrão de aço",
      "bahia 2025",
      "2025",
      "bahia feminino",
      "feminino bahia",
      "feminino",
    ],
    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/bahia/25-26-01-f/bahia0.jpg",
      "/images/brasil/serie-a/bahia/25-26-01-f/bahia1.jpg",
    ],
  },
  {
    id: 56,
    pais: "brasil",
    liga: "serie-a",
    time: "bahia",
    nome: "Bahia 25/26 Uniforme 2 ",
    aliases: [
      "bahia",
      "esporte clube bahia",
      "ec bahia",
      "tricolor de aço",
      "tricolor",
      "bahia ba",
      "esquadrão",
      "esquadrão de aço",
      "bahia 2025",
      "2025",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/bahia/25-26-02/bahia0.jpg",
      "/images/brasil/serie-a/bahia/25-26-02/bahia1.jpg",
      "/images/brasil/serie-a/bahia/25-26-02/bahia2.jpg",
      "/images/brasil/serie-a/bahia/25-26-02/bahia3.jpg",
      "/images/brasil/serie-a/bahia/25-26-02/bahia4.jpg",
    ],
  },
  {
    id: 57,
    pais: "brasil",
    liga: "serie-a",
    time: "bahia",
    nome: "Bahia 25/26 Edição Especial Super Homem ",
    aliases: [
      "bahia",
      "esporte clube bahia",
      "ec bahia",
      "tricolor de aço",
      "tricolor",
      "bahia ba",
      "esquadrão",
      "esquadrão de aço",
      "bahia 2025",
      "2025",
      "bahia edição especial ",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/bahia/25-26-04-es/bahia0.jpg",
      "/images/brasil/serie-a/bahia/25-26-04-es/bahia1.jpg",
      "/images/brasil/serie-a/bahia/25-26-04-es/bahia2.jpg",
      "/images/brasil/serie-a/bahia/25-26-04-es/bahia3.jpg",
      "/images/brasil/serie-a/bahia/25-26-04-es/bahia4.jpg",
    ],
  },
  {
    id: 58,
    pais: "brasil",
    liga: "serie-a",
    time: "bahia",
    nome: "Bahia 25/26 Edição Especial Super Homem (Feminino) ",
    aliases: [
      "bahia",
      "esporte clube bahia",
      "ec bahia",
      "tricolor de aço",
      "tricolor",
      "bahia ba",
      "esquadrão",
      "esquadrão de aço",
      "bahia 2025",
      "2025",
      "bahia feminino",
      "feminino bahia",
      "feminino",
      "bahia edição especial ",
    ],
    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/bahia/25-26-04-es-f/bahia0.jpg",
      "/images/brasil/serie-a/bahia/25-26-04-es-f/bahia1.jpg",
      "/images/brasil/serie-a/bahia/25-26-04-es-f/bahia2.jpg",
      "/images/brasil/serie-a/bahia/25-26-04-es-f/bahia3.jpg",
      "/images/brasil/serie-a/bahia/25-26-04-es-f/bahia4.jpg",
    ],
  },
  {
    id: 59,
    pais: "brasil",
    liga: "serie-a",
    time: "bahia",
    nome: "Bahia 25/26 Uniforme de Treino (Verde)",
    aliases: [
      "bahia",
      "esporte clube bahia",
      "ec bahia",
      "tricolor de aço",
      "tricolor",
      "bahia ba",
      "esquadrão",
      "esquadrão de aço",
      "bahia 2025",
      "2025",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/bahia/25-26-04/bahia0.jpg",
      "/images/brasil/serie-a/bahia/25-26-04/bahia1.jpg",
      "/images/brasil/serie-a/bahia/25-26-04/bahia2.jpg",
      "/images/brasil/serie-a/bahia/25-26-04/bahia3.jpg",
      "/images/brasil/serie-a/bahia/25-26-04/bahia4.jpg",
    ],
  },
  {
    id: 60,
    pais: "brasil",
    liga: "serie-a",
    time: "bahia",
    nome: "Bahia 25/26 Edição Especial (Vermelha)",
    aliases: [
      "bahia",
      "esporte clube bahia",
      "ec bahia",
      "tricolor de aço",
      "tricolor",
      "bahia ba",
      "esquadrão",
      "esquadrão de aço",
      "bahia 2025",
      "2025",
      "bahia edição especial ",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/bahia/25-26-05-es/bahia0.jpg",
      "/images/brasil/serie-a/bahia/25-26-05-es/bahia1.jpg",
      "/images/brasil/serie-a/bahia/25-26-05-es/bahia2.jpg",
      "/images/brasil/serie-a/bahia/25-26-05-es/bahia3.jpg",
      "/images/brasil/serie-a/bahia/25-26-05-es/bahia4.jpg",
    ],
  },
  {
    id: 61,
    pais: "brasil",
    liga: "serie-a",
    time: "bahia",
    nome: "Bahia 25/26 Uniforme de Goleiro (Amarela) ",
    aliases: [
      "bahia",
      "esporte clube bahia",
      "ec bahia",
      "tricolor de aço",
      "tricolor",
      "bahia ba",
      "esquadrão",
      "esquadrão de aço",
      "bahia 2025",
      "2025",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/bahia/25-26-06/bahia0.jpg",
      "/images/brasil/serie-a/bahia/25-26-06/bahia1.jpg",
      "/images/brasil/serie-a/bahia/25-26-06/bahia2.jpg",
      "/images/brasil/serie-a/bahia/25-26-06/bahia3.jpg",
      "/images/brasil/serie-a/bahia/25-26-06/bahia4.jpg",
    ],
  },
  {
    id: 62,
    pais: "brasil",
    liga: "serie-a",
    time: "bahia",
    nome: "Bahia 25/26 Uniforme de Goleiro (Preta) ",
    aliases: [
      "bahia",
      "esporte clube bahia",
      "ec bahia",
      "tricolor de aço",
      "tricolor",
      "bahia ba",
      "esquadrão",
      "esquadrão de aço",
      "bahia 2025",
      "2025",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/bahia/25-26-06-gp/bahia0.jpg",
      "/images/brasil/serie-a/bahia/25-26-06-gp/bahia1.jpg",
      "/images/brasil/serie-a/bahia/25-26-06-gp/bahia2.jpg",
      "/images/brasil/serie-a/bahia/25-26-06-gp/bahia3.jpg",
      "/images/brasil/serie-a/bahia/25-26-06-gp/bahia4.jpg",
    ],
  },
  {
    id: 63,
    pais: "brasil",
    liga: "serie-a",
    time: "bahia",
    nome: "Bahia 25/26 Edição Especial Black November (Preta) ",
    aliases: [
      "bahia",
      "esporte clube bahia",
      "ec bahia",
      "tricolor de aço",
      "tricolor",
      "bahia ba",
      "esquadrão",
      "esquadrão de aço",
      "bahia 2025",
      "2025",
      "bahia edição especial ",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/bahia/25-26-07-es/bahia0.jpg",
      "/images/brasil/serie-a/bahia/25-26-07-es/bahia1.jpg",
      "/images/brasil/serie-a/bahia/25-26-07-es/bahia2.jpg",
      "/images/brasil/serie-a/bahia/25-26-07-es/bahia3.jpg",
      "/images/brasil/serie-a/bahia/25-26-07-es/bahia4.jpg",
    ],
  },
  {
    id: 64,
    pais: "brasil",
    liga: "serie-a",
    time: "bahia",
    nome: "Bahia 25/26 Edição Especial Black November (Branca)",
    aliases: [
      "bahia",
      "esporte clube bahia",
      "ec bahia",
      "tricolor de aço",
      "tricolor",
      "bahia ba",
      "esquadrão",
      "esquadrão de aço",
      "bahia 2025",
      "2025",
      "bahia edição especial ",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/bahia/25-26-08-es/bahia0.jpg",
      "/images/brasil/serie-a/bahia/25-26-08-es/bahia1.jpg",
      "/images/brasil/serie-a/bahia/25-26-08-es/bahia2.jpg",
      "/images/brasil/serie-a/bahia/25-26-08-es/bahia3.jpg",
      "/images/brasil/serie-a/bahia/25-26-08-es/bahia4.jpg",
    ],
  },
  {
    id: 65,
    pais: "brasil",
    liga: "serie-a",
    time: "bahia",
    nome: "Bahia 25/26 Edição Especial (Bege) ",
    aliases: [
      "bahia",
      "esporte clube bahia",
      "ec bahia",
      "tricolor de aço",
      "tricolor",
      "bahia ba",
      "esquadrão",
      "esquadrão de aço",
      "bahia 2025",
      "2025",
      "bahia edição especial ",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/bahia/25-26-09-es/bahia0.png",
      "/images/brasil/serie-a/bahia/25-26-09-es/bahia1.png",
      "/images/brasil/serie-a/bahia/25-26-09-es/bahia2.png",
      "/images/brasil/serie-a/bahia/25-26-09-es/bahia3.png",
      "/images/brasil/serie-a/bahia/25-26-09-es/bahia4.png",
    ],
  },
  {
    id: 66,
    pais: "brasil",
    liga: "serie-a",
    time: "bahia",
    nome: "Bahia 24/25 Uniforme 01",
    aliases: [
      "bahia",
      "esporte clube bahia",
      "ec bahia",
      "tricolor de aço",
      "tricolor",
      "bahia ba",
      "esquadrão",
      "esquadrão de aço",
      "bahia 2024",
      "2024",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/bahia/24-25-01/bahia0.jpg",
      "/images/brasil/serie-a/bahia/24-25-01/bahia1.jpg",
      "/images/brasil/serie-a/bahia/24-25-01/bahia2.jpg",
      "/images/brasil/serie-a/bahia/24-25-01/bahia3.jpg",
      "/images/brasil/serie-a/bahia/24-25-01/bahia4.jpg",
    ],
  },
  {
    id: 67,
    pais: "brasil",
    liga: "serie-a",
    time: "bahia",
    nome: "Bahia 24/25 Calção 01",
    aliases: [
      "bahia",
      "esporte clube bahia",
      "ec bahia",
      "tricolor de aço",
      "tricolor",
      "bahia ba",
      "esquadrão",
      "esquadrão de aço",
      "bahia 2024",
      "2024",
      "bahia calção",
      "calção bahia",
      "calção",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/bahia/24-25-01-s/bahia0.jpg",
      "/images/brasil/serie-a/bahia/24-25-01-s/bahia1.jpg",
      "/images/brasil/serie-a/bahia/24-25-01-s/bahia2.jpg",
      "/images/brasil/serie-a/bahia/24-25-01-s/bahia3.jpg",
      "/images/brasil/serie-a/bahia/24-25-01-s/bahia4.jpg",
    ],
  },
  {
    id: 68,
    pais: "brasil",
    liga: "serie-a",
    time: "bahia",
    nome: "Bahia 24/25 Camisa 01 (Feminino)",
    aliases: [
      "bahia",
      "esporte clube bahia",
      "ec bahia",
      "tricolor de aço",
      "tricolor",
      "bahia ba",
      "esquadrão",
      "esquadrão de aço",
      "bahia 2024",
      "2024",
      "bahia feminino",
      "feminino bahia",
      "feminino",
    ],
    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/bahia/24-25-01-f/bahia0.jpg",
      "/images/brasil/serie-a/bahia/24-25-01-f/bahia1.jpg",
      "/images/brasil/serie-a/bahia/24-25-01-f/bahia2.jpg",
      "/images/brasil/serie-a/bahia/24-25-01-f/bahia3.jpg",
      "/images/brasil/serie-a/bahia/24-25-01-f/bahia4.jpg",
    ],
  },
  {
    id: 69,
    pais: "brasil",
    liga: "serie-a",
    time: "bahia",
    nome: "Bahia 24/25 Camisa 02",
    aliases: [
      "bahia",
      "esporte clube bahia",
      "ec bahia",
      "tricolor de aço",
      "tricolor",
      "bahia ba",
      "esquadrão",
      "esquadrão de aço",
      "bahia 2024",
      "2024",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/bahia/24-25-02/bahia0.jpg",
      "/images/brasil/serie-a/bahia/24-25-02/bahia1.jpg",
      "/images/brasil/serie-a/bahia/24-25-02/bahia2.jpg",
      "/images/brasil/serie-a/bahia/24-25-02/bahia3.jpg",
      "/images/brasil/serie-a/bahia/24-25-02/bahia4.jpg",
    ],
  },
  {
    id: 70,
    pais: "brasil",
    liga: "serie-a",
    time: "bahia",
    nome: "Bahia 24/25 Camisa 02 (Feminino)",
    aliases: [
      "bahia",
      "esporte clube bahia",
      "ec bahia",
      "tricolor de aço",
      "tricolor",
      "bahia ba",
      "esquadrão",
      "esquadrão de aço",
      "bahia 2024",
      "2024",
      "bahia feminino",
      "feminino bahia",
      "feminino",
    ],
    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/bahia/24-25-02-f/bahia0.jpg",
      "/images/brasil/serie-a/bahia/24-25-02-f/bahia1.jpg",
      "/images/brasil/serie-a/bahia/24-25-02-f/bahia2.jpg",
      "/images/brasil/serie-a/bahia/24-25-02-f/bahia3.jpg",
      "/images/brasil/serie-a/bahia/24-25-02-f/bahia4.jpg",
    ],
  },
  {
    id: 71,
    pais: "brasil",
    liga: "serie-a",
    time: "bahia",
    nome: "Bahia 24/25 Camisa 03",
    aliases: [
      "bahia",
      "esporte clube bahia",
      "ec bahia",
      "tricolor de aço",
      "tricolor",
      "bahia ba",
      "esquadrão",
      "esquadrão de aço",
      "bahia 2024",
      "2024",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/bahia/24-25-03/bahia0.jpg",
      "/images/brasil/serie-a/bahia/24-25-03/bahia1.jpg",
      "/images/brasil/serie-a/bahia/24-25-03/bahia2.jpg",
      "/images/brasil/serie-a/bahia/24-25-03/bahia3.jpg",
      "/images/brasil/serie-a/bahia/24-25-03/bahia4.jpg",
    ],
  },
  {
    id: 72,
    pais: "brasil",
    liga: "serie-a",
    time: "bahia",
    nome: "Bahia 24/25 Edição Especial Azul ",
    aliases: [
      "bahia",
      "esporte clube bahia",
      "ec bahia",
      "tricolor de aço",
      "tricolor",
      "bahia ba",
      "esquadrão",
      "esquadrão de aço",
      "bahia 2024",
      "2024",
      "bahia edição especial ",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/bahia/24-25-05-es/bahia0.jpg",
      "/images/brasil/serie-a/bahia/24-25-05-es/bahia1.jpg",
      "/images/brasil/serie-a/bahia/24-25-05-es/bahia2.jpg",
      "/images/brasil/serie-a/bahia/24-25-05-es/bahia3.jpg",
      "/images/brasil/serie-a/bahia/24-25-05-es/bahia4.jpg",
    ],
  },
  {
    id: 73,
    pais: "brasil",
    liga: "serie-a",
    time: "bahia",
    nome: "Bahia 24/25 Edição Especial de Aniversário ",
    aliases: [
      "bahia",
      "esporte clube bahia",
      "ec bahia",
      "tricolor de aço",
      "tricolor",
      "bahia ba",
      "esquadrão",
      "esquadrão de aço",
      "bahia 2024",
      "2024",
      "bahia edição especial ",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/bahia/24-25-06-es1/bahia0.jpg",
      "/images/brasil/serie-a/bahia/24-25-06-es1/bahia1.jpg",
      "/images/brasil/serie-a/bahia/24-25-06-es1/bahia2.jpg",
      "/images/brasil/serie-a/bahia/24-25-06-es1/bahia3.jpg",
      "/images/brasil/serie-a/bahia/24-25-06-es1/bahia4.jpg",
    ],
  },
  {
    id: 74,
    pais: "brasil",
    liga: "serie-a",
    time: "bahia",
    nome: "Bahia 23/24 Uniforme 01",
    aliases: [
      "bahia",
      "esporte clube bahia",
      "ec bahia",
      "tricolor de aço",
      "tricolor",
      "bahia ba",
      "esquadrão",
      "esquadrão de aço",
      "bahia 2023",
      "2023",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/bahia/23-24-01/bahia0.jpg",
      "/images/brasil/serie-a/bahia/23-24-01/bahia1.jpg",
      "/images/brasil/serie-a/bahia/23-24-01/bahia2.jpg",
      "/images/brasil/serie-a/bahia/23-24-01/bahia3.jpg",
      "/images/brasil/serie-a/bahia/23-24-01/bahia4.jpg",
    ],
  },
  {
    id: 75,
    pais: "brasil",
    liga: "serie-a",
    time: "bahia",
    nome: "Bahia 23/24 Uniforme 02",
    aliases: [
      "bahia",
      "esporte clube bahia",
      "ec bahia",
      "tricolor de aço",
      "tricolor",
      "bahia ba",
      "esquadrão",
      "esquadrão de aço",
      "bahia 2023",
      "2023",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/bahia/23-24-02/bahia0.jpg",
      "/images/brasil/serie-a/bahia/23-24-02/bahia1.jpg",
      "/images/brasil/serie-a/bahia/23-24-02/bahia2.jpg",
      "/images/brasil/serie-a/bahia/23-24-02/bahia3.jpg",
      "/images/brasil/serie-a/bahia/23-24-02/bahia4.jpg",
    ],
  },
  {
    id: 76,
    pais: "brasil",
    liga: "serie-a",
    time: "bahia",
    nome: "Bahia 23/24 Uniforme 03",
    aliases: [
      "bahia",
      "esporte clube bahia",
      "ec bahia",
      "tricolor de aço",
      "tricolor",
      "bahia ba",
      "esquadrão",
      "esquadrão de aço",
      "bahia 2023",
      "2023",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/bahia/23-24-03/bahia0.jpg",
      "/images/brasil/serie-a/bahia/23-24-03/bahia1.jpg",
      "/images/brasil/serie-a/bahia/23-24-03/bahia2.jpg",
      "/images/brasil/serie-a/bahia/23-24-03/bahia3.jpg",
      "/images/brasil/serie-a/bahia/23-24-03/bahia4.jpg",
    ],
  },
  {
    id: 77,
    pais: "brasil",
    liga: "serie-a",
    time: "bahia",
    nome: "Bahia 23/24 Uniforme 03 (Feminino)",
    aliases: [
      "bahia",
      "esporte clube bahia",
      "ec bahia",
      "tricolor de aço",
      "tricolor",
      "bahia ba",
      "esquadrão",
      "esquadrão de aço",
      "bahia 2023",
      "2023",
      "bahia feminino",
      "feminino bahia",
      "feminino",
    ],
    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/bahia/23-24-04-f/bahia0.jpg",
      "/images/brasil/serie-a/bahia/23-24-04-f/bahia1.jpg",
      "/images/brasil/serie-a/bahia/23-24-04-f/bahia2.jpg",
      "/images/brasil/serie-a/bahia/23-24-04-f/bahia3.jpg",
      "/images/brasil/serie-a/bahia/23-24-04-f/bahia4.jpg",
    ],
  },
  {
    id: 78,
    pais: "brasil",
    liga: "serie-a",
    time: "bahia",
    nome: "Bahia 21/22 Uniforme 01",
    aliases: [
      "bahia",
      "esporte clube bahia",
      "ec bahia",
      "tricolor de aço",
      "tricolor",
      "bahia ba",
      "esquadrão",
      "esquadrão de aço",
      "bahia 2021",
      "2021",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/bahia/21-22-01/bahia0.jpg",
      "/images/brasil/serie-a/bahia/21-22-01/bahia1.jpg",
      "/images/brasil/serie-a/bahia/21-22-01/bahia2.jpg",
      "/images/brasil/serie-a/bahia/21-22-01/bahia3.jpg",
      "/images/brasil/serie-a/bahia/21-22-01/bahia4.jpg",
    ],
  },
  {
    id: 79,
    pais: "brasil",
    liga: "serie-a",
    time: "bahia",
    nome: "Bahia 21/22 Uniforme 01",
    aliases: [
      "bahia",
      "esporte clube bahia",
      "ec bahia",
      "tricolor de aço",
      "tricolor",
      "bahia ba",
      "esquadrão",
      "esquadrão de aço",
      "bahia 2021",
      "2021",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/bahia/21-22-02/bahia0.jpg",
      "/images/brasil/serie-a/bahia/21-22-02/bahia1.jpg",
      "/images/brasil/serie-a/bahia/21-22-02/bahia2.jpg",
      "/images/brasil/serie-a/bahia/21-22-02/bahia3.jpg",
      "/images/brasil/serie-a/bahia/21-22-02/bahia4.jpg",
    ],
  },
  {
    id: 80,
    pais: "brasil",
    liga: "serie-a",
    time: "bahia",
    nome: "Bahia 13/14 Uniforme 01 Retro",
    aliases: [
      "bahia",
      "esporte clube bahia",
      "ec bahia",
      "tricolor de aço",
      "tricolor",
      "bahia ba",
      "esquadrão",
      "esquadrão de aço",
      "bahia 2013",
      "2013",
      "retro bahia",
      "bahia retro",
      "retro",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/bahia/13-14-01/bahia0.jpg",
      "/images/brasil/serie-a/bahia/13-14-01/bahia1.jpg",
      "/images/brasil/serie-a/bahia/13-14-01/bahia2.jpg",
      "/images/brasil/serie-a/bahia/13-14-01/bahia3.jpg",
      "/images/brasil/serie-a/bahia/13-14-01/bahia4.jpg",
    ],
  },
  {
    id: 81,
    pais: "brasil",
    liga: "serie-a",
    time: "bahia",
    nome: "Bahia 13/14 Uniforme 02 Retro",
    aliases: [
      "bahia",
      "esporte clube bahia",
      "ec bahia",
      "tricolor de aço",
      "tricolor",
      "bahia ba",
      "esquadrão",
      "esquadrão de aço",
      "bahia 2013",
      "2013",
      "retro bahia",
      "bahia retro",
      "retro",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/bahia/13-14-02/bahia0.png",
      "/images/brasil/serie-a/bahia/13-14-02/bahia1.png",
      "/images/brasil/serie-a/bahia/13-14-02/bahia2.png",
      "/images/brasil/serie-a/bahia/13-14-02/bahia3.png",
      "/images/brasil/serie-a/bahia/13-14-02/bahia4.png",
    ],
  },
  {
    id: 82,
    pais: "brasil",
    liga: "serie-a",
    time: "bahia",
    nome: "Bahia 98/99 Uniforme 1 Retro ",
    aliases: [
      "bahia",
      "esporte clube bahia",
      "ec bahia",
      "tricolor de aço",
      "tricolor",
      "bahia ba",
      "esquadrão",
      "esquadrão de aço",
      "bahia 1998",
      "1998",
      "retro bahia",
      "bahia retro",
      "retro",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/bahia/98-99-01/bahia0.jpg",
      "/images/brasil/serie-a/bahia/98-99-01/bahia1.jpg",
      "/images/brasil/serie-a/bahia/98-99-01/bahia2.jpg",
      "/images/brasil/serie-a/bahia/98-99-01/bahia3.jpg",
      "/images/brasil/serie-a/bahia/98-99-01/bahia4.jpg",
    ],
  },
  {
    id: 83,
    pais: "brasil",
    liga: "serie-a",
    time: "bahia",
    nome: "Bahia 96/97 Uniforme 2 Retro ",
    aliases: [
      "bahia",
      "esporte clube bahia",
      "ec bahia",
      "tricolor de aço",
      "tricolor",
      "bahia ba",
      "esquadrão",
      "esquadrão de aço",
      "bahia 1996",
      "1996",
      "retro bahia",
      "bahia retro",
      "retro",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/bahia/96-97-02/bahia0.jpg",
      "/images/brasil/serie-a/bahia/96-97-02/bahia1.jpg",
      "/images/brasil/serie-a/bahia/96-97-02/bahia2.jpg",
      "/images/brasil/serie-a/bahia/96-97-02/bahia3.jpg",
      "/images/brasil/serie-a/bahia/96-97-02/bahia4.jpg",
    ],
  },
  {
    id: 84,
    pais: "brasil",
    liga: "serie-a",
    time: "bahia",
    nome: "Bahia 95/96 Uniforme 1 Retro ",
    aliases: [
      "bahia",
      "esporte clube bahia",
      "ec bahia",
      "tricolor de aço",
      "tricolor",
      "bahia ba",
      "esquadrão",
      "esquadrão de aço",
      "bahia 1995",
      "1995",
      "retro bahia",
      "bahia retro",
      "retro",
    ],
    tipo: "masculino",
    categoria: "retro",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/bahia/95-96-01/bahia0.jpg",
      "/images/brasil/serie-a/bahia/95-96-01/bahia1.jpg",
      "/images/brasil/serie-a/bahia/95-96-01/bahia2.jpg",
      "/images/brasil/serie-a/bahia/95-96-01/bahia3.jpg",
      "/images/brasil/serie-a/bahia/95-96-01/bahia4.jpg",
    ],
  },
  {
    id: 85,
    pais: "brasil",
    liga: "serie-a",
    time: "bahia",
    nome: "Bahia 95/96 Uniforme 2 Retro ",
    aliases: [
      "bahia",
      "esporte clube bahia",
      "ec bahia",
      "tricolor de aço",
      "tricolor",
      "bahia ba",
      "esquadrão",
      "esquadrão de aço",
      "bahia 1995",
      "1995",
      "retro bahia",
      "bahia retro",
      "retro",
    ],
    tipo: "masculino",
    categoria: "retro",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/bahia/95-96-02/bahia0.jpg",
      "/images/brasil/serie-a/bahia/95-96-02/bahia1.jpg",
      "/images/brasil/serie-a/bahia/95-96-02/bahia2.jpg",
      "/images/brasil/serie-a/bahia/95-96-02/bahia3.jpg",
      "/images/brasil/serie-a/bahia/95-96-02/bahia4.jpg",
    ],
  },
];

export default bahia;
